<app-header></app-header>
<section class="blog blog-grid pt-70 pb-90">
    <div class="container pairblank">
        <div class="page__section">
            <nav class="breadcrumb breadcrumb_type5" aria-label="Breadcrumb">
                <ol class="breadcrumb__list r-list">
                    <li class="breadcrumb__group">
                        <a [routerLink]="['/ipo-calendar']" title="Halka Arz Takvimi"
                            class="breadcrumb__point r-link" i18n="@@ipoCalendar">Halka Arz Takvimi</a>
                        <span class="breadcrumb__divider" aria-hidden="true">›</span>
                    </li>
                    <li class="breadcrumb__group">
                        <span class="breadcrumb__point" aria-current="page">
                            <h1 class="h6 mt-2">{{ipo?.name}} <span class="visible-title" i18n="@@ipoStock">Hisse Halka Arz</span></h1>
                        </span>
                    </li>
                </ol>
            </nav>
        </div>
        <div class="row" style="padding: 15px;">
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm">
                <nav class="accordion arrows">
                    <header class="box public-offering-header">
                        <h2>{{ipo?.code}}</h2>
                        <h3>{{ipo?.name}}</h3>
                    </header>
                    <div class="row">
                        <h4 class="h4 mb-3 mt-3" i18n="@@ipoDetail">Halka Arz Detayları : </h4>
                        <div class="col" style="font-weight:bold;" i18n="@@ipoDate">Arz Tarihi</div>
                        <div class="col">{{ipo?.startDateString}}~{{ipo?.endDateString}} </div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;" i18n="@@brokerageFirm">Aracı Kurum</div>
                        <div class="col">{{ipo?.brokerageFirm}}</div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;" i18n="@@price">Fiyatı/Aralığı</div>
                        <div class="col">{{ipo?.lowPrice | currency:'TRY'}}{{ipo?.lowPrice!=ipo?.highPrice?' - '+(ipo?.highPrice | currency:'TRY'):''}}</div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;" i18n="@@sharePiece">Pay</div>
                        <div class="col">{{ipo?.sharePiece | number}}</div>
                        <div class="w-100"></div>
                        <div *ngIf="ipo?.shareAdditional" class="col" style="font-weight:bold; margin-bottom: 10px;" i18n="@@shareAdditional">Ek Pay</div>
                        <div *ngIf="ipo?.shareAdditional" class="col">{{ipo?.shareAdditional | number}}</div>
                        <div class="w-100"></div>
                        <div class="col href-wrap" style="font-weight:bold;" i18n="@@distributionMethod">Dagıtım Şekli</div>
                        <div class="col href-wrap">
                            <ng-container
                                *ngIf="ipo?.distributionMethod =='Oransal Dağıtım';  then iAmDMDone; else iAmDMNotDone">
                            </ng-container>
                            <ng-template #iAmDMDone>
                                <a target="_blank" class="href" alt="Oransal Dağıtım" title="Oransal Dağıtım"
                                    href="/info/oransal-dagitim"><strong>{{ipo?.distributionMethod}}</strong></a>
                            </ng-template>
                            <ng-template #iAmDMNotDone>
                                <a target="_blank" class="href" alt="Eşit Dağıtım" title="Eşit Dağıtım"
                                    href="/info/oransal-dagitim#equal-distribution"><strong>{{ipo?.distributionMethod}}</strong></a>
                            </ng-template>
                        </div>
                        <div class="w-100"></div>
                        <div class="col href-wrap" style="font-weight:bold;" i18n="@@marketInformation">Pazar</div>
                        <div class="col href-wrap">
                            <ng-container *ngIf="ipo?.marketInformation=='Ana Pazar';  then iAmDone; else iAmNotDone">
                            </ng-container>
                            <ng-template #iAmDone>
                                <a target="_blank" class="href" alt="Ana Pazar Nedir" title="Ana Pazar Nedir"
                                    href="/info/ana-pazar-nedir"><strong>{{ipo?.marketInformation }}</strong></a>
                            </ng-template>
                            <ng-template #iAmNotDone>
                                <a target="_blank" class="href" alt="Yıldız Pazar Nedir" title="Yıldız Pazar Nedir"
                                    href="/info/yildiz-pazar-nedir"><strong>{{ipo?.marketInformation }}</strong></a>
                            </ng-template>
                        </div>
                    </div>
                    <br>
                    <div class="row" *ngFor="let link of linkList ; trackBy: trackByFnLink">
                        <div class="col" style="font-weight:bold;"><a class="text-link" href="{{link.url}}">📌
                                {{link.title}}</a></div>
                        <div class="w-100"></div>
                    </div>
                    <br>
                    <app-financial-statement [code]="ipo?.code"></app-financial-statement>
                    <app-stock-chart [code]="ipo?.code"></app-stock-chart>
                    <app-company [code]="ipo?.code"></app-company>
                </nav>
                <div class="widget market-pricing market-list card mb-3"
                    style="position: relative; padding:10px; margin-top:50px;">
                    <div class="row">
                        <div class="col-4" style="width:auto;height:auto;">
                            <picture>
                                <source media="(max-width: 192px)" srcset="{{domainURL}}halka-arz.webp" />
                                <source media="(min-width: 192px)" srcset="{{domainURL}}halka-arz.webp" />
                                <img loading="lazy" width="192px" height="108px" src="{{domainURL}}halka-arz.webp"
                                    alt="Halka Arz" title="Halka Arz">
                            </picture>
                        </div>

                        <div class="col"><strong>{{ipo?.name}} Halka Arz</strong>, ve daha fazla şirketin halka arz
                            tarihleri için<a [routerLink]="['/ipo-calendar']" title="Halka Arz Takvimi">
                                <strong> Halka Arz Takvimi</strong></a> sayfasını ziyaret edebilirsiniz.</div>
                        <div class="w-100"></div>
                        <br>
                        <p>Şirketlerin, hisselerin ve güncel borsa analizlerine <strong><a [routerLink]="['/analysis']"
                                    title="Analiz">Analiz </a></strong>sayfamızdan ulaşabilirsiniz.</p>
                    </div>
                </div>
                <div class="widget market-pricing market-list card mb-3"
                    style="position: relative; padding:10px; margin-top:50px;">
                    <app-comment [commentCount]="commentCount" [title]="title" [rootId]="rootId"></app-comment>
                </div>
                <br>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <div class="widget widget-recent-posts">
                    <app-draft-month [toYear]="toYear"></app-draft-month>
                    <app-draft-dividend [toYear]="toYear"></app-draft-dividend>
                    <app-summary-info></app-summary-info>
                    <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis>
                </div>
            </div>
        </div>
        <p class="visible-title">
            <strong>{{ipo?.code}} Hisse </strong>
            <strong>{{ipo?.name}} Hisse </strong>
            <strong i18n="@@ipoCalendar">Halka Arz</strong>
            <strong i18n="@@ipoDate">Halka Arz Tarihleri</strong>
        </p>
    </div>
</section>
<app-footer></app-footer>